
import {useEffect, useState} from "react";

import {Simulate} from "react-dom/test-utils";
import {useLocation, useNavigate} from "react-router-dom";
import {toast} from "react-toastify";
import DashboardLayout from "../../examples/LayoutContainers/DashboardLayout";
import { getReportImages } from "../../actions/reports/reports";
import { ShimmerFeaturedGallery, ShimmerSocialPost } from "react-shimmer-effects";

export default function ReportListImage(){
    const baseUrl = process.env.REACT_APP_IMAGE_URL;
    const [images,setImages] = useState([]);
    const [loading,setLoading] = useState(true);
    const location = useLocation();
    const navigate = useNavigate();
    const { id } = location.state;

    async function getData(){
        try{
            setLoading(true);
            const data = await getReportImages(id);
            setLoading(false);
            const fullImagePaths = JSON.parse(data.message.data.files).map((path) => baseUrl + path);
            setImages(fullImagePaths)
        }catch (e){
            toast.error('تصویر یافت نشد!')
            navigate(-1);
        }
    }
    useEffect(() => {
        getData();
    }, []);
    return (
        <DashboardLayout>
            {loading && <ShimmerFeaturedGallery row={2} col={2} card frameHeight={600} />
            }
            {!loading && <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
                {images.map((item, index) => (
                    <div key={index}>
                        <a href={item} target="_blank" rel="noopener noreferrer">
                            <img className="h-150 max-w-full rounded-lg" src={item} alt="تصاویر"/>
                        </a>
                    </div>
                ))}

            </div>}

        </DashboardLayout>
    );
}

